import { Button } from "antd";
import styled from "styled-components";
export const LeftButton = styled(Button) `
  &&& {
    margin: 0.5rem;
    margin-left: 1rem;
    padding: 0;
    text-align: left;
  }
`;
export const RightButton = styled(Button) `
  &&& {
    float: right;
    margin: 0.5rem;
    margin-right: 1rem;
    padding: 0;
    text-align: right;
  }
`;
